import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  status: {
    danger: "orange",
  },
});

export default theme;
